import React from 'react';

interface LineEditIconProps {
  size?: number;
  color?: string;
}

export const LineEditIcon: React.FC<LineEditIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.8291 15.3135L9.36464 18.849L5.54795 19.7298C5.18792 19.8129 4.86524 19.4902 4.94833 19.1302L5.8291 15.3135Z"
        fill={color}
      />
      <path
        d="M16.789 4.35355C16.9843 4.15829 17.3009 4.15829 17.4961 4.35355L20.3246 7.18198C20.5198 7.37724 20.5198 7.69383 20.3246 7.88909L10.0715 18.1421L6.53598 14.6066L16.789 4.35355Z"
        fill={color}
      />
    </svg>
  );
};
